import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-intro-start',
  templateUrl: './intro-start.component.html',
  styleUrls: ['./intro-start.component.scss'],
})
export class IntroStartComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
